import React, { useEffect } from "react";
import SolutionForm from "./SolutionForm";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSolution } from "../../../contexts/SolutionsContext";
import { TOAST_CLASSES } from "../../../utils/constants";
import { useDashboard } from "../../../contexts/DashboardContext";
import "../css/edit.sol.css";

const EditSolution = () => {
  const {
    solutions,
    initializeEdit,
    getSolution,
  } = useSolution();
  const { showToastMessage } = useDashboard();

  const location = useLocation();

  const navigate = useNavigate();

  const { id } = useParams();

  const solutionId = id || (location.state && location.state.solutionId);

  useEffect(() => {
    if (!solutionId) {
      navigate("/solutions", { replace: true });
      return;
    }

    const initialize = async () => {
      const solution = solutions?.find(
        (sol) => sol?.solution_id === solutionId
      );

      if (solution) {
        initializeEdit(solution);
      } else {
        try {
          const fetchedSolution = await getSolution(solutionId);

          if (fetchedSolution) {
            initializeEdit(fetchedSolution);
          } else {
            setTimeout(() => {
              navigate("/solutions", { replace: true });
            }, 1000);
          }
        } catch (error) {
          showToastMessage("Failed to fetch data.", TOAST_CLASSES?.ERROR);

          setTimeout(() => {
            navigate("/solutions", { replace: true });
          }, 1000);
        }
      }
    };

    initialize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solutionId, solutions?.length]);

  if (!solutionId) {
    return null;
  }

  return <SolutionForm type="edit" solutionId={solutionId} />;
};

export default EditSolution;
